// extracted by mini-css-extract-plugin
export default {"loaderContainer":"styles_loaderContainer__K13GD","loader":"styles_loader__h8P86"};